import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ShippingSpeedEstimatedDeliveryDate from './ShippingSpeedEstimatedDeliveryDate';
import ShippingSpeedOption from './ShippingSpeedOption';
import shippingSpeedShape from './shippingSpeedShape';

const STANDARD_SHIP_SPEED_IDS = ['1', '11'];

export default function HomeDeliveryShippingSpeedOption({
  shippingSpeed, onChangeShippingSpeed, textFor, ...props
}) {
  const {
    inStockItemsOnlyTMNTValue,
    estDeliveryTMNTValue,
  } = textFor;

  const eddDate = useMemo(() => {
    if (!shippingSpeed.displayEDDRange || !shippingSpeed.minEstimatedDeliveryDateDisplay) {
      return shippingSpeed.estimatedDeliveryDateDisplay;
    }
    if (!STANDARD_SHIP_SPEED_IDS.includes(shippingSpeed.externalId)) {
      return shippingSpeed.maxEstimatedDeliveryDateDisplay;
    }
    if (shippingSpeed.showMaxEstimatedDeliveryDate) {
      return `${shippingSpeed.minEstimatedDeliveryDateDisplay} - ${shippingSpeed.maxEstimatedDeliveryDateDisplay}`;
    }
    return shippingSpeed.minEstimatedDeliveryDateDisplay;
  }, [shippingSpeed]);

  return (
    <ShippingSpeedOption
      shippingSpeed={shippingSpeed}
      onChangeShippingSpeed={onChangeShippingSpeed}
      {...props}
    >
      {!shippingSpeed.displayEDDRange ? (
        <ShippingSpeedEstimatedDeliveryDate
          estimatedDeliveryDateDisplay={`${estDeliveryTMNTValue.value}: ${eddDate} ${inStockItemsOnlyTMNTValue.value}`}
        />
      ) : (
        <div>
          <ShippingSpeedEstimatedDeliveryDate
            estimatedDeliveryDateDisplay={`${estDeliveryTMNTValue.value}: ${eddDate}`}
          />
          <span className="inStock">
            {inStockItemsOnlyTMNTValue.value}
          </span>
        </div>

      )}

    </ShippingSpeedOption>
  );
}

HomeDeliveryShippingSpeedOption.defaultProps = {
  shippingSpeed: undefined,
  onChangeShippingSpeed: undefined,
  textFor: {
    inStockItemsOnlyTMNTValue: {
      key: 'CHK_ESTIMATED_DELIVERY_INSTOCK',
      value: 'in-stock items only',
    },
    estDeliveryTMNTValue: {
      key: 'CHK_EST_DELIVERY',
      value: 'Est. Delivery',
    },
  },
};

HomeDeliveryShippingSpeedOption.propTypes = {
  shippingSpeed: shippingSpeedShape,
  onChangeShippingSpeed: PropTypes.func,
  textFor: PropTypes.shape({
    inStockItemsOnlyTMNTValue: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    estDeliveryTMNTValue: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  }),
};
